<template>
  <div id="">
    <div
      class="container-title-page with-background"
      :style="{
        background: 'url(' + trip.Elem_Image_Header + ')',
      }"
    >
      <div class="box-text-content-title reservation-title" style="z-index: 10">
        <h2>{{ trip.NomBase }}</h2>
        <p>
          <strong
            >{{ trip.Description }} <br />
            {{ trip.Date_Texte }}</strong
          >
        </p>
        <p>
          <strong
            >{{ trip.Jours_Circuit }} <br />
            {{ trip.Jours_AvantDepart }}</strong
          >
        </p>
      </div>
    </div>
    <div id="page" class="page-content with-header-background">
      <div class="contents-profils-form reservation-box">
        <div v-if="mode === 'trip'" class="title-reservation">
          <img src="../assets/earth.svg" />
          <h4>Ma réservation</h4>
        </div>
        <div v-if="mode === 'souvenir'" class="title-reservation">
          <img src="../assets/earth.svg" />
          <h4>Historique de ce voyage</h4>
        </div>
        <div ref="separation"></div>
        <div v-if="mode === 'souvenir'" class="title-sections-form">
          <p id="Photo">Album photo</p>
        </div>
        <div
          v-if="mode === 'souvenir'"
          class="row-container-mr with-sidebar row-documents"
        >
          <div>
            <div class="box-documents">
              <img src="../assets/guide_du_voyageur.svg" />
              <div class="documents-info">
                <span class="documents-title">ALBUM PHOTO</span>
                <a class="album" target="_blank" :href="trip.Facebook_Url"
                  >Voir l’album photo souvenir Facebook</a
                >
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="mode === 'trip' && avisImportant.length !== 0"
          class="title-sections-form"
        >
          <p id="avisImportant">avis important</p>
        </div>
        <div
          v-if="mode === 'trip' && avisImportant.length !== 0"
          class="with-sidebar row-container-date-importante row-container-mr"
        >
          <div class="liste-date">
            <div
              class="box-date"
              v-for="(avis, index) in avisImportant"
              :key="index"
            >
              <img class="calendar" src="../assets/calendrier.svg" />
              <div class="date-info">
                <span class="date-title">{{ avis.date }}</span>
                <span class="sub-title-date">{{ avis.message }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="mode === 'trip' && trip.IsFit !== 1"
          class="title-sections-form with-margin-top"
        >
          <p id="VosChoix">Vos choix</p>
        </div>

        <div
          v-if="mode === 'trip' && trip.IsFit !== 1"
          class="container-row-choix with-sidebar row-container-mr"
        >
          <div
            class="row-choix"
            v-for="(participant, index) in participants"
            :key="index"
          >
            <div class="choix-header">
              <div class="profil-photo">
                <img src="" />
              </div>
              <div class="profil-nom">
                <h4>{{ participant.NomComplet }}</h4>
              </div>
            </div>
            <div class="autorisation-profil">
              <img class="appareil-photo" src="../assets/appareil-photo.svg" />
              <div class="radio-autorisation">
                <span class="title-input"
                  >Voyages Lambert et ses représentants prennent des photos
                  durant les voyages afin de faire un album souvenir hébergé sur
                  Facebook et partagé sur votre Espace client. J’accepte d’être
                  pris en photo à ces fins.
                </span>
                <div class="autorizationRadioBox">
                  <input
                    :id="'autorizationYes' + participant.a__pk"
                    class="radio-custom"
                    type="radio"
                    :checked="participant.Pref_AutorisationPhoto === 1"
                    @click="updateAutorisationPhoto(participant, 1)"
                  />
                  <label :for="'autorizationYes' + participant.a__pk" class="radio-custom-label-yes"
                    >Oui</label
                  >
                  <input
                    :id="'autorizationNo' + participant.a__pk"
                    class="radio-custom"
                    type="radio"
                    :checked="participant.Pref_AutorisationPhoto === 0"
                    @click="updateAutorisationPhoto(participant, 0);"
                  />
                  <label :for="'autorizationNo' + participant.a__pk" class="radio-custom-label-no"
                    >Non</label
                  >
                </div>
              </div>
            </div>
            <div class="solde-profil">
              <span class="depot-info">
                $ Dépot : {{ participant.Pref_Paiements_Depot_Choix }}
              </span>
              <span class="solde-info">
                $ Solde : {{ participant.Pref_Paiements_Solde_Choix }}
              </span>
            </div>
          </div>
        </div>

        <div v-if="mode === 'trip'" class="title-sections-form with-margin-top">
          <p id="DateImportante">Dates importantes</p>
        </div>

        <div
          v-if="mode === 'trip'"
          class="with-sidebar row-container-date-importante row-container-mr"
        >
          <div class="liste-date">
            <div class="box-date" v-if="trip.Date_NonRemboursement_Texte">
              <img class="calendar" src="../assets/calendrier.svg" />
              <div class="date-info">
                <span class="date-title">{{
                  trip.Date_NonRemboursement_Texte
                }}</span>
                <span class="sub-title-date" v-if="trip.IsFit !== 1"
                  >Date de non remboursement du dépôt</span
                >
                <span class="sub-title-date" v-else
                  >Date de non-remboursement du deuxième dépôt</span
                >
              </div>
            </div>

            <div class="box-date" v-if="trip.Date_Depart_Texte">
              <img class="calendar" src="../assets/calendrier.svg" />
              <div class="date-info">
                <span class="date-title">{{ trip.Date_Depart_Texte }}</span>
                <span class="sub-title-date" v-if="trip.IsFit !== 1"
                  >Date de départ</span
                >
                <span class="sub-title-date" v-else
                  >Date de départ de votre croisière</span
                >
              </div>
            </div>

            <div class="box-date" v-if="trip.Date_Solde_Texte">
              <img class="calendar" src="../assets/calendrier.svg" />
              <div class="date-info">
                <span class="date-title">{{ trip.Date_Solde_Texte }}</span>
                <span class="sub-title-date">Date du solde</span>
              </div>
            </div>

            <div class="box-date" v-if="trip.Date_Retour_Texte">
              <img class="calendar" src="../assets/calendrier.svg" />
              <div class="date-info">
                <span class="date-title">{{ trip.Date_Retour_Texte }}</span>
                <span class="sub-title-date">Date de retour</span>
              </div>
            </div>

            <div
              class="box-date"
              v-if="
                trip.RencontrePreDepart_Date_Texte &&
                trip.RencontrePreDepart_Heure
              "
            >
              <img class="calendar" src="../assets/calendrier.svg" />
              <div class="date-info">
                <span class="date-title">{{
                  trip.RencontrePreDepart_Date_Texte
                }}</span>
                <span class="sub-title-date"
                  >Rencontre pré-départ avec votre accompagnateur à
                  {{ trip.RencontrePreDepart_Heure }}</span
                >
                <a
                  :href="mainParticipant.RencontrePreDepart_Url"
                  class="lien-date"
                  target="_blank"
                  v-if="
                    mainParticipant.RencontrePreDepart_Url &&
                    trip.RencontrePreDepart_Expiree !== 1
                  "
                >
                  Cliquer ici pour vous joindre à la réunion
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          class="title-sections-form with-margin-top"
          v-if="mode === 'trip' && trip.IsFit !== 1"
        >
          <p id="Info">Informations pré-départ</p>
        </div>

        <div
          class="row-predepart with-sidebar row-container-mr"
          v-if="mode === 'trip' && trip.IsFit !== 1"
        >
          <div class="container-pre-video">
            <h5 class="title-capsule">Capsule pré-départ</h5>
            <span class="description-capsule">
              Cette courte vidéo vous offre de l’information et quelques
              conseils pratiques pour votre voyage. À visionner avant votre
              rencontre pré-départ.
            </span>
            <div class="video-capsule">
              <b-embed
                type="iframe"
                aspect="16by9"
                :src="param.Doc_Video_CapsulePreDepart"
                allowfullscreen
              />
            </div>
          </div>
          <div class="container-pre-date">
            <h5 class="title-capsule">Rencontre pré-départ</h5>
            <div class="liste-date">
              <div class="box-date">
                <img class="calendar" src="../assets/calendrier.svg" />
                <div class="date-info">
                  <span class="date-title">{{
                    trip.RencontrePreDepart_Date_Texte
                  }}</span>
                  <span
                    v-if="trip.RencontrePreDepart_Expiree !== 1"
                    class="sub-title-date"
                    >La rencontre aura lieu à
                    {{ trip.RencontrePreDepart_Heure }}</span
                  >
                  <span
                    v-if="trip.RencontrePreDepart_Expiree === 1"
                    class="sub-title-date"
                    >La rencontre a eu lieu</span
                  >
                  <a
                    :href="mainParticipant.RencontrePreDepart_Url"
                    target="_blank"
                    v-if="
                      mainParticipant.RencontrePreDepart_Url &&
                      trip.RencontrePreDepart_Expiree !== 1
                    "
                    class="lien-date"
                    >Cliquez ici pour vous joindre à la réunion en ligne</a
                  >
                  <a
                    :href="mainParticipant.RencontrePreDepart_Url"
                    target="_blank"
                    v-if="
                      mainParticipant.RencontrePreDepart_Url &&
                      trip.RencontrePreDepart_Expiree === 1
                    "
                    class="lien-date"
                    >Cliquez ici pour revisionner la réunion en ligne</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            documents ||
            (circuit && circuit.length !== 0 && circuit[0].length !== 0)
          "
        >
          <div class="title-sections-form with-margin-top">
            <p id="Doc">DOCUMENTS DU CIRCUIT</p>
          </div>
          <div class="row-container-mr with-sidebar row-documents">
            <div class="liste-documents">
              <div
                v-for="(document, index) in documents"
                :key="index"
                class="cell"
              >
                <div
                  class="box-documents"
                  v-if="document.section === 'circuit'"
                >
                  <a
                    class="box-documents"
                    style="cursor: pointer"
                    @click="downloadDoc(document.id)"
                  >
                    <img :src="'data:image/png;base64,' + document.icone" />
                    <div class="documents-info">
                      <span class="documents-title">{{ document.titre }}</span>
                      <span class="sub-title-documents">{{
                        document.description
                      }}</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div v-for="(participant, index) in circuit" :key="index">
              <div
                class="row-choix"
                v-if="circuit && circuit[index].length !== 0"
              >
                <div class="choix-header">
                  <div class="profil-photo">
                    <img src="" />
                  </div>
                  <div class="profil-nom">
                    <h4>{{ participants[index].NomComplet }}</h4>
                  </div>
                </div>
                <div
                  v-for="(documentP, index) in participant"
                  :key="index"
                  class="download-list cell"
                >
                  <div
                    class="profil-download-list"
                    v-if="documentP.section === 'circuit'"
                  >
                    <a
                      class="link-download"
                      style="cursor: pointer"
                      @click="downloadDoc(documentP.id)"
                    >
                      <div class="documents-info">
                        <span class="documents-title">{{
                          documentP.titre
                        }}</span>
                        <span class="sub-title-documents">{{
                          documentP.description
                        }}</span>
                      </div>
                      <DownloadButton />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="title-sections-form with-margin-top"
          v-if="
            documents || (vols && vols.length !== 0 && vols[0].length !== 0)
          "
        >
          <p id="Vols">VOLS ET TRANSFERTS</p>
        </div>

        <div class="row-container-mr with-sidebar row-vols">
          <div class="liste-documents">
            <div
              v-for="(document, index) in documents"
              :key="index"
              class="cell"
            >
              <div class="box-documents" v-if="document.section === 'vols'">
                <a
                  class="box-documents"
                  style="cursor: pointer"
                  @click="downloadDoc(document.id)"
                >
                  <img :src="'data:image/png;base64,' + document.icone" />
                  <div class="documents-info">
                    <span class="documents-title">{{ document.titre }}</span>
                    <span class="sub-title-documents">{{
                      document.description
                    }}</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div v-for="(participant, index) in vols" :key="index">
            <div class="row-choix" v-if="vols && vols[index].length !== 0">
              <div class="choix-header">
                <div class="profil-photo">
                  <img src="" />
                </div>
                <div class="profil-nom">
                  <h4>{{ participants[index].NomComplet }}</h4>
                </div>
              </div>
              <div
                v-for="(documentP, index) in participant"
                :key="index"
                class="download-list cell"
              >
                <div
                  class="profil-download-list"
                  v-if="documentP.section === 'vols'"
                >
                  <a
                    class="link-download"
                    style="cursor: pointer"
                    @click="downloadDoc(documentP.id)"
                  >
                    <div class="documents-info">
                      <span class="documents-title">{{ documentP.titre }}</span>
                      <span class="sub-title-documents">{{
                        documentP.description
                      }}</span>
                    </div>
                    <DownloadButton />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="title-sections-form with-margin-top"
          v-if="visas.length !== 0 && visas[0].length !== 0"
        >
          <p id="Visas">VISAS</p>
        </div>
        <div class="row-container-mr with-sidebar row-vols">
          <div v-for="(participant, index) in visas" :key="index">
            <div class="row-choix" v-if="visas && visas[index].length !== 0">
              <div class="choix-header">
                <div class="profil-photo">
                  <img src="" />
                </div>
                <div class="profil-nom">
                  <h4>{{ participants[index].NomComplet }}</h4>
                </div>
              </div>
              <div
                v-for="(documentP, indexP) in participant"
                :key="indexP"
                class="download-list cell"
              >
                <div
                  class="profil-download-list"
                  v-if="documentP.section === 'visas'"
                >
                  <a
                    class="link-download"
                    style="cursor: pointer"
                    @click="downloadDoc(documentP.id)"
                  >
                    <div class="documents-info">
                      <span class="documents-title">{{ documentP.titre }}</span>
                      <span class="sub-title-documents">{{
                        documentP.description
                      }}</span>
                    </div>
                    <DownloadButton />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="Doc_Assurances && Doc_Assurances.length !== 0">
          <div class="title-sections-form with-margin-top">
            <p id="Assurance">ASSURANCE</p>
          </div>
          <div class="row-container-mr with-sidebar row-assurance">
            <div v-for="(docAssurance, index) in Doc_Assurances" :key="index">
              <div class="row-choix" v-if="Doc_Assurances[index].length !== 0">
                <div>
                  <div class="choix-header">
                    <div class="profil-photo">
                      <img src="" />
                    </div>
                    <div class="profil-nom">
                      <h4>{{ participants[index].NomComplet }}</h4>
                    </div>
                  </div>
                  <div class="container-table-profil">
                    <b-table
                      :fields="fields"
                      :items="docAssurance"
                      class="profil-table"
                    >
                      <template #cell(container)="row">
                        <a @click="downloadDoc(row.value)" class="pointeur">
                          <DownloadButton />
                        </a>
                      </template>
                      <template #cell(prospectus)="row">
                        <a @click="downloadDoc(row.value)" class="pointeur">
                          <DownloadButton />
                        </a>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="billing && Object.keys(billing).length !== 0">
          <div class="title-sections-form with-margin-top">
            <p id="Facturation">Facturation</p>
          </div>
          <div class="row-container-mr with-sidebar row-facturation">
            <div v-for="(participant, index) in participants" :key="index">
              <div class="row-choix" v-if="billing[participant.a__pk]">
                <div class="choix-header">
                  <div class="profil-photo">
                    <img src="" />
                  </div>
                  <div class="profil-nom">
                    <h4>{{ participants[index].NomComplet }}</h4>
                  </div>
                </div>
                <div class="container-table-profil">
                  <b-table
                    :fields="fields2"
                    :items="billing[participant.a__pk]"
                    class="profil-table"
                  >
                    <template #cell(Montant)="row">
                      {{ row.value }} $
                    </template>
                    <template #cell(a_fk_Containers)="row">
                      <a
                        class="BillLink pointeur"
                        align-v="center"
                        @click="downloadDoc(row.value)"
                      >
                        <DownloadButton />
                      </a>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="showRecommandation" v-if="propositionCircuit.length !== 0">
          <div class="title-sections-form with-margin-top">
            <p id="Recommandation">Recommandations</p>
          </div>
          <div class="row-container-mr with-sidebar">
            <carousel
              :loop="true"
              :per-page="2"
              :autoplayTimeout="4000"
              :autoplay="true"
            >
              <slide
                class="slideW"
                v-for="(proposition, index) in propositionCircuit"
                :key="index"
                @slide-click="tripPage(proposition.url)"
              >
                <div class="box-depart trip">
                  <img :src="proposition.image" fluid class="img-box-depart" />
                  <div class="depart-box-info">
                    <h4 class="depart-box-title">{{ proposition.titre }}</h4>
                    <div class="depart-box-description">
                      <p>
                        {{ proposition.nbJours }} <br />
                        {{ proposition.dates }}
                      </p>
                    </div>
                  </div>
                  <div class="depart-box-footer">
                    <span>{{ proposition.countdown }}</span>
                  </div>
                </div>
              </slide>
            </carousel>
          </div>
        </div>

        <div v-if="propositionDerniere.length !== 0">
          <div class="title-sections-form with-margin-top">
            <p id="LastChance">Dernière chance</p>
          </div>
          <div class="row-container-mr with-sidebar row-recommandation">
            <carousel
              :loop="true"
              :per-page="2"
              :autoplayTimeout="4000"
              :autoplay="true"
            >
              <slide
                class="slideW"
                v-for="(proposition, index) in propositionDerniere"
                :key="index"
                @slide-click="tripPage(proposition.url)"
              >
                <div class="box-depart trip">
                  <div class="box-place-dispo">
                    <div
                      class="depart-places-dispo"
                      style="background: #bab65b"
                    >
                      {{ proposition.derniereChance }}
                    </div>
                    <div class="depart-places-dispo-image plurial"></div>
                    <div class="depart-places-dispo-image-tag"></div>
                  </div>
                  <img :src="proposition.image" fluid class="img-box-depart" />
                  <div class="depart-box-info">
                    <h4 class="depart-box-title">{{ proposition.titre }}</h4>
                    <div class="depart-box-description">
                      <p>
                        {{ proposition.nbJours }} <br />
                        {{ proposition.dates }}
                      </p>
                    </div>
                  </div>
                  <div class="depart-box-footer">
                    <span>{{ proposition.countdown }}</span>
                  </div>
                </div>
              </slide>
            </carousel>
          </div>
        </div>

        <br />
      </div>
    </div>
    <div
      class="sidebar-container"
      v-if="showMenu"
      :style="{
        top: distanceMenuHaut,
        position: positionMenuDroite,
        right: distanceMenuDroite,
        width: largeurBoite,
      }"
    >
      <div class="menu-sidebar-container">
        <ul class="menu-sidebar">
          <li>
            <a
              href="#Photo"
              :class="sideBarClass.photo"
              v-if="verifId('Photo')"
            >
              <span class="title-menu">Album Photo</span>
              <span class="line-hover"></span>
            </a>
            <a
              href="#avisImportant"
              :class="sideBarClass.avis"
              v-if="verifId('avisImportant')"
            >
              <span class="title-menu">Avis Important</span>
              <span class="line-hover"></span>
            </a>
            <a
              href="#VosChoix"
              :class="sideBarClass.choix"
              v-if="verifId('VosChoix')"
            >
              <span class="title-menu">Vos choix</span>
              <span class="line-hover"></span>
            </a>
            <a
              href="#DateImportante"
              :class="sideBarClass.dates"
              v-if="verifId('DateImportante')"
            >
              <span class="title-menu">Dates importantes</span>
              <span class="line-hover"></span>
            </a>
            <a href="#Info" :class="sideBarClass.info" v-if="verifId('Info')">
              <span class="title-menu">Informations pré-départ</span>
              <span class="line-hover"></span>
            </a>
            <a href="#Doc" :class="sideBarClass.circuit" v-if="verifId('Doc')">
              <span class="title-menu">Documents du circuit</span>
              <span class="line-hover"></span>
            </a>
            <a href="#Vols" :class="sideBarClass.vols" v-if="verifId('Vols')">
              <span class="title-menu">Vols et transferts</span>
              <span class="line-hover"></span>
            </a>
            <a
              href="#Visas"
              :class="sideBarClass.visas"
              v-if="verifId('Visas')"
            >
              <span class="title-menu">Visas</span>
              <span class="line-hover"></span>
            </a>
            <a
              href="#Assurance"
              :class="sideBarClass.assurance"
              v-if="verifId('Assurance')"
            >
              <span class="title-menu">Assurance</span>
              <span class="line-hover"></span>
            </a>
            <a
              href="#Facturation"
              :class="sideBarClass.facturation"
              v-if="verifId('Facturation')"
            >
              <span class="title-menu">Facturation</span>
              <span class="line-hover"></span>
            </a>
            <a
              href="#Recommandation"
              :class="sideBarClass.recommandation"
              v-if="verifId('Recommandation')"
            >
              <span class="title-menu">Recommandations</span>
              <span class="line-hover"></span>
            </a>
            <a
              href="#LastChance"
              :class="sideBarClass.lastChance"
              v-if="verifId('LastChance')"
            >
              <span class="title-menu">Dernière chance</span>
              <span class="line-hover"></span>
            </a>
          </li>
        </ul>
      </div>
      <div class="depart-proposition" v-if="propositionCircuit.length !== 0">
        <h5 class="title-proposition">VOUS AIMERIEZ PEUT-ÊTRE</h5>
        <div class="list-departs-sidebar">
          <carousel
            :loop="true"
            :per-page="1"
            :autoplay="true"
            :autoplayTimeout="4000"
          >
            <slide
              class="slideW"
              v-for="(proposition, index) in propositionCircuit"
              :key="index"
              @slide-click="tripPage(proposition.url)"
            >
              <div class="box-depart trip">
                <img :src="proposition.image" fluid class="img-box-depart" />
                <div class="depart-box-info">
                  <h4 class="depart-box-title">{{ proposition.titre }}</h4>
                  <div class="depart-box-description">
                    <p>
                      {{ proposition.nbJours }} <br />
                      {{ proposition.dates }}
                    </p>
                  </div>
                </div>
                <div class="depart-box-footer">
                  <span>{{ proposition.countdown }}</span>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DownloadButton from "@/components/DownloadButton.vue";
export default {
  name: "",
  components: {
    DownloadButton,
  },
  data: () => ({
    positionMenuDroite: "absolute",
    distanceMenuDroite: "330px",
    distanceMenuHaut: "449px",
    largeurBoite: "450px",
    heureRencontre: "",
    showMenu: true,
    mainParticipant: {},
    propositionCircuit: [],
    propositionDerniere: [],
    mode: "trip",
    sideBarClass: {
      photo: "",
      avis: "",
      choix: "",
      dates: "",
      info: "",
      circuit: "",
      vols: "",
      visas: "",
      assurance: "",
      facturation: "",
      recommandation: "",
      lastChance: "",
    },
    avisImportant: [],
    options: [
      {
        text: "Oui",
        value: 1,
      },
      {
        text: "Non",
        value: "",
      },
    ],
    documents: [],
    documentsP: [],
    visas: [],
    vols: [],
    circuit: [],
    fields: [
      {
        key: "dateAchat",
        label: "Date",
        sortable: true,
      },
      {
        key: "forfait",
        label: "Forfait",
        sortable: false,
      },
      {
        key: "couverture",
        label: "Couverture",
        sortable: false,
      },
      {
        key: "nbrJours",
        label: "Durée",
        sortable: false,
      },
      {
        key: "noContrat",
        label: "Contrat",
        sortable: false,
      },
      {
        key: "container",
        label: "POLICE D'ASSURANCE",
      },
      {
        key: "prospectus",
        label: "CONTRAT",
      },
    ],
    fields2: [
      {
        key: "a_fk_Containers",
        label: "",
        sortable: false,
      },
      {
        key: "Date",
        label: "Date",
        sortable: true,
      },
      {
        key: "Type",
        label: "Description",
        sortable: false,
      },
      {
        key: "Montant",
        label: "Montant",
        sortable: false,
      },
    ],
    Doc_Assurances: [],
    autorization: "",
  }),
  watch: {
    autorization() {
      console.log(this.autorization);
    },
    clients() {
      for (let i in this.clients) {
        if (this.clients[i].Validation_isUser === 1) {
          this.propositionCircuit = JSON.parse(
            this.clients[i].Propositions_Circuits_Cards
          );
          this.propositionDerniere = JSON.parse(
            this.clients[i].Propositions_DernieresChances_Cards
          );
        }
      }
      this.getTrip(this.$route.params.id);
    },
    trip() {
      //this.getParticipantList();
      this.getParticipantList(this.trip.a__pk);
      this.rencontreSansSeconde();
      if (this.trip.AvisImportants) {
        this.avisImportant = JSON.parse(this.trip.AvisImportants);
      }
    },
    participants() {
      let user = "";
      this.getParam();

      for (let j in this.participants) {
        this.getBilling(this.participants[j].a__pk);
        if (this.participants[j]["Validation_isUser"] === 1) {
          user = this.participants[j];
          this.mainParticipant = this.participants[j];
          if (user.Validation_NouveauxDocuments === 1) {
            this.putParticipant({
              id: user.a__pk,
              param: {
                fields: {
                  Validation_NouveauxDocuments: "",
                },
              },
              tripId: this.trip.a__pk,
            });
          }
        }
      }
    },
    billing() {
      for (let i in this.participants) {
        let participant = this.participants[i];
        let doc = this.billing[participant.a__pk];
        let facture;
        for (let index in doc) {
          facture = doc[index].a_fk_Containers;
        }
      }
    },
    param() {
      this.documents = [];
      this.documentsP = [];
      this.vols = [];
      this.visas = [];
      this.circuit = [];
      let keys = Object.keys(this.param.Values_Documents);
      for (let i in keys) {
        let key = keys[i];
        let document = this.param.Values_Documents[key];
        if (document.type === "participant") {
          for (let j in this.participants) {
            if (this.participants[j][key]) {
              if (this.documentsP[j] === undefined) {
                this.documentsP.push([]);
              }

              let participant = this.participants[j];

              let pDocument = JSON.parse(JSON.stringify(document));
              pDocument.id = participant[key];
              if (key === "Doc_Autre") {
                pDocument.titre = participant["Doc_Autre_Titre"];
              }
              if (key === "Doc_Vols_Autre") {
                pDocument.titre = participant["Doc_Vols_Autre_Titre"];
              }
              this.documentsP[j].push(pDocument);
              if (this.visas[j] === undefined) {
                this.visas.push([]);
              }
              if (this.vols[j] === undefined) {
                this.vols.push([]);
              }
              if (this.circuit[j] === undefined) {
                this.circuit.push([]);
              }

              if (pDocument.section === "visas") {
                this.visas[j].push(pDocument);
              }
              if (pDocument.section === "vols") {
                this.vols[j].push(pDocument);
              }
              if (pDocument.section === "circuit") {
                this.circuit[j].push(pDocument);
              }
            }
          }
        } else if (document.type === "participant-commun") {
          for (let j in this.participants) {
            if (this.participants[j]["Validation_isUser"] === 1) {
              if (this.participants[j][key]) {
                let pDocument = JSON.parse(JSON.stringify(document));
                pDocument.id = this.participants[j][key];
                if (key === "Doc_Autre") {
                  pDocument.titre = this.participants[j]["Doc_Autre_Titre"];
                } else if (key === "Doc_Vols_Autre") {
                  pDocument.titre =
                    this.participants[j]["Doc_Vols_Autre_Titre"];
                }
                this.documents.push(pDocument);
              }
            }
          }
        } else {
          if (this.trip[key]) {
            document.id = this.trip[key];
            this.documents.push(document);
          }
        }
      }
      this.documents.sort(function (a, b) {
        return a.ordre - b.ordre;
      });
      for (let j in this.documentsP) {
        this.documentsP[j].sort(function (a, b) {
          return a.ordre - b.ordre;
        });
      }
      for (let i in this.participants) {
        let participant = this.participants[i];
        if (
          this.Doc_Assurances[i] === undefined &&
          participant.Doc_Assurances
        ) {
          this.Doc_Assurances.push([]);
        }
        if (participant.Doc_Assurances) {
          let doc = JSON.parse(participant.Doc_Assurances);
          this.Doc_Assurances[i] = doc;
          let police;
          let prospectus;
          for (let index in doc) {
            police = doc[index].container;
            prospectus = doc[index].prospectus;
          }
        }
      }
    },
  },
  computed: {
    ...mapState({
      trip: (state) => state.triplist.current,
      participants: (state) => state.participant.list,
      param: (state) => state.param.param,
      doc: (state) => state.container.list,
      customList: (state) => state.triplist.customList,
      billing: (state) => state.billing.list,
      clients: (state) => state.client.list,
    }),
    openDoc(id) {
      if (this.doc[id]) {
        return this.doc[id].base64;
      }
      return "";
    },
  },
  methods: {
    ...mapActions([
      "getTrip",
      "getParticipantList",
      "getParam",
      "getContainer",
      "putParticipant",
      "postTripList",
      "getBilling",
      "resetBilling",
      "getClients",
    ]),
    verifId(id) {
      let present = document.getElementById(id);
      return present;
    },
    //this.putParticipant({ id: participant.a__pk, param: { fields: {Pref_AutorisationPhoto: participant.Pref_AutorisationPhoto} } }); save
    //Pref_AutorisationPhoto
    handleScroll() {
      this.sticky_relocate();
      let Photo;
      let Avis;
      let Choix;
      let Dates;
      let PreDepart;
      let Circuit;
      let Vols;
      let Visas;
      let Assurance;
      let Facturation;
      let Recommandations;
      let DerniereChance;

      let id0 = document.getElementById("Photo");
      if (id0 && id0 !== null) {
        Photo = id0.getBoundingClientRect().top - 100;
      }
      id0 = document.getElementById("avisImportant");
      if (id0 && id0 !== null) {
        Avis = id0.getBoundingClientRect().top - 100;
      }
      id0 = document.getElementById("VosChoix");
      if (id0 && id0 !== null) {
        Choix = id0.getBoundingClientRect().top - 100;
      }
      id0 = document.getElementById("DateImportante");
      if (id0 && id0 !== null) {
        Dates = id0.getBoundingClientRect().top - 100;
      }
      id0 = document.getElementById("Info");
      if (id0 && id0 !== null) {
        PreDepart = id0.getBoundingClientRect().top - 100;
      }
      id0 = document.getElementById("Doc");
      if (id0 && id0 !== null) {
        Circuit = id0.getBoundingClientRect().top - 100;
      }
      id0 = document.getElementById("Vols");
      if (id0 && id0 !== null) {
        Vols = id0.getBoundingClientRect().top - 100;
      }
      id0 = document.getElementById("Visas");
      if (id0 && id0 !== null) {
        Visas = id0.getBoundingClientRect().top - 100;
      }
      id0 = document.getElementById("Assurance");
      if (id0 && id0 !== null) {
        Assurance = id0.getBoundingClientRect().top - 100;
      }
      id0 = document.getElementById("Facturation");
      if (id0 && id0 !== null) {
        Facturation = id0.getBoundingClientRect().top - 100;
      }
      id0 = document.getElementById("Recommandation");
      if (id0 && id0 !== null) {
        Recommandations = id0.getBoundingClientRect().top - 100;
      }
      id0 = document.getElementById("LastChance");
      if (id0 && id0 !== null) {
        DerniereChance = id0.getBoundingClientRect().top - 100;
      }

      if (Photo && Photo < 0 && Photo > -215) {
        this.sideBarClass.photo = "sidebar";
        this.sideBarClass.avis = "";
        this.sideBarClass.choix = "";
        this.sideBarClass.dates = "";
        this.sideBarClass.info = "";
        this.sideBarClass.circuit = "";
        this.sideBarClass.vols = "";
        this.sideBarClass.visas = "";
        this.sideBarClass.assurance = "";
        this.sideBarClass.facturation = "";
        this.sideBarClass.recommandation = "";
        this.sideBarClass.lastChance = "";
      } else if (Avis && Avis < 0 && Avis > -370) {
        this.sideBarClass.photo = "";
        this.sideBarClass.avis = "sidebar";
        this.sideBarClass.choix = "";
        this.sideBarClass.dates = "";
        this.sideBarClass.info = "";
        this.sideBarClass.circuit = "";
        this.sideBarClass.vols = "";
        this.sideBarClass.visas = "";
        this.sideBarClass.assurance = "";
        this.sideBarClass.facturation = "";
        this.sideBarClass.recommandation = "";
        this.sideBarClass.lastChance = "";
      } else if (Choix && Choix < 0 && Choix > -798) {
        this.sideBarClass.photo = "";
        this.sideBarClass.avis = "";
        this.sideBarClass.choix = "sidebar";
        this.sideBarClass.dates = "";
        this.sideBarClass.info = "";
        this.sideBarClass.circuit = "";
        this.sideBarClass.vols = "";
        this.sideBarClass.visas = "";
        this.sideBarClass.assurance = "";
        this.sideBarClass.facturation = "";
        this.sideBarClass.recommandation = "";
        this.sideBarClass.lastChance = "";
      } else if (Dates && Dates < 0 && Dates > -438) {
        this.sideBarClass.photo = "";
        this.sideBarClass.avis = "";
        this.sideBarClass.choix = "";
        this.sideBarClass.dates = "sidebar";
        this.sideBarClass.info = "";
        this.sideBarClass.circuit = "";
        this.sideBarClass.vols = "";
        this.sideBarClass.visas = "";
        this.sideBarClass.assurance = "";
        this.sideBarClass.facturation = "";
        this.sideBarClass.recommandation = "";
        this.sideBarClass.lastChance = "";
      } else if (PreDepart && PreDepart < 0 && PreDepart > -690) {
        this.sideBarClass.photo = "";
        this.sideBarClass.avis = "";
        this.sideBarClass.choix = "";
        this.sideBarClass.dates = "";
        this.sideBarClass.info = "sidebar";
        this.sideBarClass.circuit = "";
        this.sideBarClass.vols = "";
        this.sideBarClass.visas = "";
        this.sideBarClass.assurance = "";
        this.sideBarClass.facturation = "";
        this.sideBarClass.recommandation = "";
        this.sideBarClass.lastChance = "";
      } else if (Circuit && Circuit < 0 && Circuit > -880) {
        this.sideBarClass.photo = "";
        this.sideBarClass.avis = "";
        this.sideBarClass.choix = "";
        this.sideBarClass.dates = "";
        this.sideBarClass.info = "";
        this.sideBarClass.circuit = "sidebar";
        this.sideBarClass.vols = "";
        this.sideBarClass.visas = "";
        this.sideBarClass.assurance = "";
        this.sideBarClass.facturation = "";
        this.sideBarClass.recommandation = "";
        this.sideBarClass.lastChance = "";
      } else if (Vols && Vols < 0 && Vols > -647) {
        this.sideBarClass.photo = "";
        this.sideBarClass.avis = "";
        this.sideBarClass.choix = "";
        this.sideBarClass.dates = "";
        this.sideBarClass.info = "";
        this.sideBarClass.circuit = "";
        this.sideBarClass.vols = "sidebar";
        this.sideBarClass.visas = "";
        this.sideBarClass.assurance = "";
        this.sideBarClass.facturation = "";
        this.sideBarClass.recommandation = "";
        this.sideBarClass.lastChance = "";
      } else if (Visas && Visas < 0 && Visas > -394) {
        this.sideBarClass.avis = "";
        this.sideBarClass.choix = "";
        this.sideBarClass.dates = "";
        this.sideBarClass.info = "";
        this.sideBarClass.circuit = "";
        this.sideBarClass.vols = "";
        this.sideBarClass.visas = "sidebar";
        this.sideBarClass.assurance = "";
        this.sideBarClass.facturation = "";
        this.sideBarClass.recommandation = "";
        this.sideBarClass.lastChance = "";
      } else if (Assurance && Assurance < 0 && Assurance > -1098) {
        this.sideBarClass.photo = "";
        this.sideBarClass.avis = "";
        this.sideBarClass.choix = "";
        this.sideBarClass.dates = "";
        this.sideBarClass.info = "";
        this.sideBarClass.circuit = "";
        this.sideBarClass.vols = "";
        this.sideBarClass.visas = "";
        this.sideBarClass.assurance = "sidebar";
        this.sideBarClass.facturation = "";
        this.sideBarClass.recommandation = "";
        this.sideBarClass.lastChance = "";
      } else if (Facturation && Facturation < 0 && Facturation > -630) {
        this.sideBarClass.photo = "";
        this.sideBarClass.avis = "";
        this.sideBarClass.choix = "";
        this.sideBarClass.dates = "";
        this.sideBarClass.info = "";
        this.sideBarClass.circuit = "";
        this.sideBarClass.vols = "";
        this.sideBarClass.visas = "";
        this.sideBarClass.assurance = "";
        this.sideBarClass.facturation = "sidebar";
        this.sideBarClass.recommandation = "";
        this.sideBarClass.lastChance = "";
      } else if (
        Recommandations &&
        Recommandations < 0 &&
        Recommandations > -630
      ) {
        this.sideBarClass.photo = "";
        this.sideBarClass.avis = "";
        this.sideBarClass.choix = "";
        this.sideBarClass.dates = "";
        this.sideBarClass.info = "";
        this.sideBarClass.circuit = "";
        this.sideBarClass.vols = "";
        this.sideBarClass.visas = "";
        this.sideBarClass.assurance = "";
        this.sideBarClass.facturation = "";
        this.sideBarClass.recommandation = "sidebar";
        this.sideBarClass.lastChance = "";
      } else if (
        DerniereChance &&
        DerniereChance < 0 &&
        DerniereChance > -630
      ) {
        this.sideBarClass.photo = "";
        this.sideBarClass.avis = "";
        this.sideBarClass.choix = "";
        this.sideBarClass.dates = "";
        this.sideBarClass.info = "";
        this.sideBarClass.circuit = "";
        this.sideBarClass.vols = "";
        this.sideBarClass.visas = "";
        this.sideBarClass.assurance = "";
        this.sideBarClass.facturation = "";
        this.sideBarClass.recommandation = "";
        this.sideBarClass.lastChance = "sidebar";
      } else {
        this.sideBarClass.photo = "";
        this.sideBarClass.avis = "";
        this.sideBarClass.choix = "";
        this.sideBarClass.dates = "";
        this.sideBarClass.info = "";
        this.sideBarClass.circuit = "";
        this.sideBarClass.vols = "";
        this.sideBarClass.visas = "";
        this.sideBarClass.assurance = "";
        this.sideBarClass.facturation = "";
        this.sideBarClass.recommandation = "";
        this.sideBarClass.lastChance = "";
      }
    },
    updateAutorisationPhoto(participant, value) {
      participant.Pref_AutorisationPhoto = value;
      this.putParticipant({
        id: participant.a__pk,
        param: {
          fields: {
            Pref_AutorisationPhoto: participant.Pref_AutorisationPhoto,
          },
        },
        tripId: this.trip.a__pk,
      });
    },
    onResize() {
      this.resizeMenuDroite();
    },
    resizeMenuDroite() {
      let largeur = window.innerWidth;
      let position = document
        .getElementById("page")
        .getBoundingClientRect().left;
      position = position + 20;
      if (largeur > 1200) {
        this.distanceMenuDroite = position + "px";
        this.largeurBoite = "300px";
        this.showMenu = true;
      } else if (largeur >= 965) {
        this.distanceMenuDroite = position + "px";
        this.largeurBoite = "33%";
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }
    },
    sticky_relocate() {
      let div_top = this.$refs["separation"].getBoundingClientRect().top - 100;
      if (div_top <= 0) {
        this.positionMenuDroite = "fixed";
        if (div_top <= 0 && div_top >= -33) {
          let test = (-div_top + 70).toString() + "px";
          this.distanceMenuHaut = test;
        } else {
          this.distanceMenuHaut = "103px";
        }
      } else {
        this.positionMenuDroite = "absolute";
        this.distanceMenuHaut = "449px";
      }
    },
    async downloadDoc(id) {
      if (id.indexOf("http") === -1) {
        // download
        document.body.classList.add("inheritCursors");
        document.body.style.cursor = "progress";
        let data = await this.getContainer(id);
        console.log(data);
        var byteCharacters = data.Base64.replace(/\r\n/g, "");
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var file = new Blob([byteArray], { type: "application/pdf;base64" });
        const link = document.createElement("a");
        link.href = "data:image/pdf;base64," + data.Base64;
        link.download = data.Filename;
        link.target = "_blank";
        link.click();
        URL.revokeObjectURL(link.href);
        document.body.style.cursor = "default";
        document.body.classList.remove("inheritCursors");
      } else {
        window.open(id, "_blank");
      }
    },
    rencontreSansSeconde() {
      let myString = this.trip.RencontreVirtuelle_Heure;
      let position = 5;
      if (myString) {
        myString =
          myString.substring(0, position) + myString.substring(position + 4);
        myString = myString.replace(":", "h");
        this.heureRencontre = myString;
      }
    },
    toTrip(a_pk) {
      window.location.href = "https://www.voyages-lambert.com/?depart=" + a_pk;
    },
    tripPage(url) {
      window.location.href = url;
    },
  },
  mounted() {
    window.scrollTo(0, -200);
    this.resizeMenuDroite();
    this.sticky_relocate();
    this.rencontreSansSeconde();
  },
  created() {
    if (this.$route.query.mode) {
      this.mode = this.$route.query.mode;
    }
    this.resetBilling();
    this.getClients();
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style lang="css" scoped>
.autorizationRadioBox {
  display: flex;
  padding-left: 28px;
}
.radio-custom {
  opacity: 0;
  position: absolute;
}

.radio-custom,
.radio-custom-label-yes,
.radio-custom-label-no {
  display: inline-block;
  vertical-align: middle;
  padding-left: 16px;
  margin-right: 24px;
  cursor: pointer;
}

.radio-custom-label {
  position: relative;
}

.radio-custom + .radio-custom-label-yes:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  border: 2px solid #000000;
  border-radius: 100%;
}

.radio-custom + .radio-custom-label-no:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  border: 2px solid #000000;
  border-radius: 100%;
}

.radio-custom:checked + .radio-custom-label-yes:before {
  content: url("../assets/checkGreen.svg");
  height: 22px;
  width: 22px;
  display: flex;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.radio-custom:checked + .radio-custom-label-no:before {
  content: url("../assets/checkRed.svg");
  height: 22px;
  width: 22px;
  display: flex;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.tete {
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center left !important;
}

.textTete {
  color: #ffffff;
  text-shadow: 1px 2px #242629;
  text-align: center;
}
.principal {
  margin-right: 9%;
  margin-left: 9%;
  padding: 1%;
  background-color: #ffffff;
}
.span {
  display: inline-block;
}
.avion {
  font-size: 40px;
}
.temps {
  font-size: 30px;
  padding-left: 10px;
  text-decoration: underline;
}
.entete {
  padding-top: 100px;
  padding-bottom: 100px;
}
.check {
  font-size: 20px;
}
.titre {
  text-decoration: underline;
  font-weight: bold;
}
.sous-titre {
  text-decoration: underline;
  font-weight: bold;
}
.link {
  padding-left: 40px;
}
.absolute {
  position: absolute;
  height: 75%;
  padding: 1%;
}
.fixed {
  position: fixed;
  height: 75%;
  padding: 1%;
}
.ombre {
  height: 3px;
  width: 60%;
  border-width: 0;
  text-align: left;
  margin-left: 0;
  margin-top: 5%;
  margin-bottom: 5%;

  color: #313439;
  background-color: #969696;
}
.space {
  margin-top: 500px;
}
.document {
  width: 100%;
  text-align: center;
  border-top: 2px solid #858585 !important;
  border-bottom: 2px solid #858585 !important;
  vertical-align: middle;
}
.iconesDoc {
  padding-top: 1%;
  padding-bottom: 1%;
  width: 10%;
  border-top: 2px solid #858585;
  border-bottom: 2px solid #858585;
}
.titreDoc {
  padding-top: 1%;
  padding-bottom: 1%;
  width: 30%;
  font-weight: bold;
  border-top: 2px solid #858585;
  border-bottom: 2px solid #858585;
}
.descriptionDoc {
  text-align: left;
  padding-top: 1%;
  width: 50%;
  padding-bottom: 1%;
  border-top: 2px solid #858585;
  border-bottom: 2px solid #858585;
}
.boutonDoc {
  padding-top: 1%;
  padding-bottom: 1%;
  width: 10%;
  border-top: 2px solid #858585;
  border-bottom: 2px solid #858585;
}
.download {
  background-color: #4faddf;
  color: #ffffff;
  border-radius: 45%;
  font-size: 25px;
}
.carreMenuDroite {
  text-align: center;
  padding-bottom: 1%;
}
.btnMenu {
  text-align: left;
  color: #ffffff;
  text-transform: uppercase;
  border-radius: 10px !important;
  border: none;
}
.paysage {
  max-height: 200px;
}
.paysage2 {
  max-height: 250px;
}
.card {
  background: #313439;
  cursor: pointer;
  height: 100%;
  overflow: hidden;
}
.card:hover {
  transform: scale(1.05);
}
.TitreCarte {
  color: #ffffff;
  font-weight: bold;
  font-size: 18px;
  min-height: 60px;
}
.DescriptionCarte {
  color: #ffffff;
  font-weight: bold;
  font-size: 14px;
}
.titreMenuDroite {
  text-shadow: 1px 1px #0d2044c7;
  text-align: center;
  color: #4f76b1;
  font-weight: bold !important;
  text-transform: uppercase;
  font-size: 20px;
}
.slideW {
  padding: 0px 5px 0px 5px;
  overflow: hidden;
}
.assuranceTab {
  overflow-x: auto;
  padding: 0px;
  margin-left: 15px !important;
}
.BillLink {
  font-weight: bold !important;
  font-size: 25px;
  color: #000000;
  vertical-align: middle;
}
.BillLink:hover {
  text-decoration: none;
}
/deep/ .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #000000;
  background-color: #000000;
}

.cell:empty {
  display: none;
}
.album {
  font-size: 16px;
  color: #e64747;
  text-decoration: underline;
  font-weight: bold;
}
.pointeur {
  cursor: pointer;
}
</style>
